// extracted by mini-css-extract-plugin
export var bold = "styles-module--bold--1N-m_";
export var button = "styles-module--button--2NV2b";
export var moyoSearchLink = "styles-module--moyoSearchLink--19_3h";
export var noMargin = "styles-module--noMargin--2T-4N";